export const serviceChangeFields = [
  { key: 'openingHours', icon: 'far fa-calendar-alt' },
  { key: 'serviceChangesOrClosures', icon: 'fas fa-home' },
  { key: 'extraServicesOrEvents', icon: 'fas fa-plus' },
  { key: 'emergencyContact', icon: 'fas fa-phone' },
  { key: 'eligibilityConditions', icon: 'fas fa-list' },
]
